import React,{useEffect, useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';


export default function Subscription__Success (props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();

    return (
        <div className={classes.root}>
            You have succesfully subscribed. Happy business :)
        </div>
    )
}

const useStyles = makeStyles({
    root: {
    }
});